/*
Обязательные классы и атрибуты для обёртки: b-btn-fav, js-btn-fav, data-ajax-url, data-book-id
Обязательно вложить внутрь svg из примера ниже
-----------------------------------------
Пример:
<button class="b-btn-fav js-btn-fav" data-ajax-url="{{ favouriteAction }}" data-book-id="{{ id }}">
    <svg class="b-btn-fav__svg">
        <path class="b-btn-fav__svg-path _img-default" d="M18.2105 1.8C17.0526 0.635294 15.5789 0 13.8947 0C12.4211 0 11.0526 0.529412 10 1.37647C8.94737 0.529412 7.57895 0 6.10526 0C2.73684 0 0 2.75294 0 6.03529C0 11.4353 9.05263 17.5765 9.47368 17.7882C9.57895 17.8941 9.78947 18 10 18C10.2105 18 10.4211 17.8941 10.5263 17.7882C11.4737 17.1529 20 11.2235 20 6.03529C20 4.44706 19.3684 2.85882 18.2105 1.8ZM6.10526 2.01176C7.36842 2.01176 8.42105 2.54118 9.26316 3.49412C9.68421 3.91765 10.4211 3.91765 10.7368 3.49412C11.4737 2.54118 12.6316 2.01176 13.8947 2.01176C14.9474 2.01176 16 2.43529 16.8421 3.17647C17.5789 3.91765 18 4.97647 18 6.03529C18 8.89412 13.7895 13.0235 10 15.7765C7.05263 13.6588 2 9.21177 2 6.03529C2 3.81176 3.78947 2.01176 6.10526 2.01176Z"/>
        <path class="b-btn-fav__svg-path _img-active" d="M18.2105 1.8C17.0526 0.635294 15.5789 0 13.8947 0C12.4211 0 11.0526 0.529412 10 1.37647C8.94737 0.529412 7.57895 0 6.10526 0C2.73684 0 0 2.75294 0 6.03529C0 11.4353 9.05263 17.5765 9.47368 17.7882C9.57895 17.8941 9.78947 18 10 18C10.2105 18 10.4211 17.8941 10.5263 17.7882C11.4737 17.1529 20 11.2235 20 6.03529C20 4.44706 19.3684 2.85882 18.2105 1.8Z"/>
    </svg>
</button>
-----------------------------------------
Для позиционирования и кастомизации обернуть в контейнер
*/


(function () {
    $ (function () {

        /*

        Кнопки

        */

        // события добавления / удаления для кнопок

        $ (document).on ('is:added', ".js-btn-fav", function (e, bookId, offerId, url, countItems) {
            window.countFav = countItems;
            $ (".js-btn-fav").filter (`[data-book-id="${bookId}"][data-offer-id="${offerId}"]`).addClass ("_active");
            makeFavPopup (url);
        });

        $ (document).on ('is:deleted', ".js-btn-fav", function (e, bookId, offerId, countItems) {
            window.countFav = countItems;
            $ (".js-btn-fav").filter (`[data-book-id="${bookId}"][data-offer-id="${offerId}"]`).removeClass ("_active");
        });

        // нажатие на кнопку избранного на товаре

        $ (document).on ("click", ".js-btn-fav", function (e) {
            e.preventDefault ();

            const $btn = $ (this);

            const ajaxUrl = $btn.data ("ajax-url");
            const bookId = $btn.data ("book-id");
            const offerId = $btn.attr ("data-offer-id"); // .attr(), потому что значение может меняться, а результат .data() кешируется
            const isDelete = $btn.is ("._active");

            // -----------

            // Фейковый ответ на аякс для удобства отладки

            // let response = {
            //     success: true,
            //     noAuth: true, // передавать, если юзер не авторизован на сайте
            //     url: "/test_url/", // ссылка на ЛК Избранное для мелкого попапа сбоку экрана
            //     imgs: { // передавать, если юзер не авторизован на сайте. Объект картинок, которую лайкнул юзер
            //         x1: "img/media/books/bailey/bailey.jpg",
            //         x2: "img/media/books/bailey/bailey@2x.jpg",
            //         x3: "img/media/books/bailey/bailey@3x.jpg"
            //     },

            //     eventsData: {
            //         price: 666
            //     },

            //     countItems: 3
            // };

            // if (response.success === true) {
            //     const url = response.url || "/";
            //     let eventCode;

            //     if (!isDelete) {
            //         // добавление в избранное
            //         eventCode = "favAdd";
            //         // триггерим событие для кнопок
            //         $btn.trigger ("is:added", [bookId, offerId, url, response.countItems]);

            //     } else {
            //         // удаление из избранного
            //         eventCode = "favDel";
            //         // триггерим событие для кнопок
            //         $btn.trigger ("is:deleted", [bookId, offerId, response.countItems]);
            //     }

            //     // собираем объект для аналитики
            //     $ (document).trigger ("uiEvent", [
            //         {
            //             event: 'UI',
            //             code: eventCode,
            //             data: {
            //                 offerId: offerId,
            //                 name: response.name,
            //                 price: response.price
            //             }
            //         }
            //     ]);

            // } else if (response.noAuth === true) {
            //     // если юзер не авторизован, кидаем клич модалке регистрации и передаём обложки книги
            //     $(document).trigger("needShow:popupLogin", [response.imgs, { isUserNoAuth: response.noAuth, offerId }] );

            // } else {
            //     $(document).trigger('is:errorModal', {title: "Произошла ошибка!", text: ""});
            // }

            // return false;

            // -----------

            const errData = {
                title: "Произошла ошибка!",
                text: ""
            };

            if (ajaxUrl !== "" && bookId !== "" && offerId !== "") {
                const promise = $.ajax ({
                    method: 'POST',
                    url: ajaxUrl,
                    data: JSON.stringify ({id: bookId, offerId: offerId, del: isDelete}),
                    dataType: 'json'
                });

                promise
                    .done (function (response) {
                        if (response.success === true) {
                            const url = response.url || "/";
                            let eventCode;

                            if (!isDelete) {
                                // добавление в избранное
                                eventCode = "favAdd";
                                // триггерим событие для кнопок
                                $btn.trigger ("is:added", [bookId, offerId, url, response.countItems]);

                            } else {
                                // удаление из избранного
                                eventCode = "favDel";
                                // триггерим событие для кнопок
                                $btn.trigger ("is:deleted", [bookId, offerId, response.countItems]);
                            }

                            // собираем объект для аналитики
                            $ (document).trigger ("uiEvent", [
                                {
                                    event: 'UI',
                                    code: eventCode,
                                    data: {
                                        offerId: globalFunctions.escapeStr (offerId),
                                        name: globalFunctions.escapeStr (response.name),
                                        price: globalFunctions.escapeStr (response.price)
                                    }
                                }
                            ]);

                        } else if (response.noAuth === true) {
                            // если юзер не авторизован, вызывается попап логина
                            // в window.productToFavourites сохраняется информация для показа в левом блоке попапа
                            window.productToFavourites = {
                                offerId: offerId,
                                isUserNoAuth: response.noAuth,
                                imgs: response.imgs
                            }
                            $ (document).trigger ("needShow:popupLogin");

                        } else {
                            $ (document).trigger ('is:errorModal', errData);
                        }
                    })
                    .fail (function (jqXHR, textStatus, errorThrown) {
                        $ (document).trigger ('is:errorModal', errData);
                    });
            }
        });

        $ (document).on ("offer:change", ".js-btn-fav", function (e, offerId, isFav) {
            const $btn = $ (this);

            $btn.attr ("data-offer-id", offerId);

            if (isFav) {
                $btn.addClass ("_active");
            } else {
                $btn.removeClass ("_active");
            }
        });


        /*

        Попап "Добавлено в избранное"

        */

        // показать попап о добавлении в избранное

        function makeFavPopup (url) {
            const textPar = "Товар успешно добавлен в&nbsp;избранное";
            const textBtn = "Перейти";

            const html =
                `
                    <div class="popup-favourites js-popup-favourites">
                    <button class="popup-favourites__close js-popup-favourites__close">
                        <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewbox="0 0 16 16">
                            <rect width="20.5702" height="2.05702" rx="1.02851" transform="matrix(0.707104 0.707109 -0.707104 0.707109 1.4541 0.000244141)" fill="#949599" stroke="#949599" stroke-width="0.3"/>
                            <rect width="20.5702" height="2.05702" rx="1.02851" transform="matrix(0.707104 -0.707109 0.707104 0.707109 0.000976562 14.5454)" fill="#949599" stroke="#949599" stroke-width="0.3"/>
                        </svg>
                    </button>
                    <p class="popup-favourites__text">${textPar}</p>
                    <a href="${url}" class="b-btn _red popup-favourites__btn">${textBtn}</a>
                    </div>
                `;
            

            if ($ (".js-popup-favourites").length === 0) {
                $ ("body").append (html).trigger ("needShow:popupFavs");
                
                $('.js-popup-favourites__close').on('click', destroyFavPopup);
            }
        }

        // уничтожить попап

        function destroyFavPopup () {
            $ (".js-popup-favourites").each (function () {
                const $_this = $ (this);

                $_this.removeClass ("_shown");

                setTimeout (function () {
                    $_this.remove ();
                }, 500);
            });
        }

        // показываем попап и регистрируем функцию удаления

        $ (document).on ("needShow:popupFavs", "body", function (e) {
            $ (".js-popup-favourites").addClass ("_shown");
            setTimeout (destroyFavPopup, 5500); // уничтожить после паузы
        });
    })
} ());
